<template>
  <v-container fluid id="home" class="home fill-height">

    <v-row v-if="isAdmin" class="text-center"> 
      <v-col>
        <h2>Admin</h2>
        <v-btn class="justify-end" @click="signOutAsAdmin" color="error" dark >Sign Out As Admin</v-btn>
        <br><br>
        <!-- Filter -->
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Filter</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-select
                  v-model="record"
                  :items="recordItems"
                  :rules="rules.text"
                  item-text="item"
                  item-value="value"
                  label="Record"
                  outlined
                  dense
                  class="px-2"
                ></v-select>
                <v-select
                  v-model="year"
                  :items="yearItems"
                  :rules="rules.text"
                  item-text="item"
                  item-value="value"
                  label="Year"
                  outlined
                  dense
                  class="px-2"
                ></v-select>
                <v-select
                  v-model="month"
                  :items="monthItems"
                  :rules="rules.text"
                  item-text="item"
                  item-value="value"
                  label="Month"
                  outlined
                  dense
                  class="px-2"
                ></v-select>
              </v-row>
              <p class="subtitle-2">*Ipodbooking: Select year only, ignore month.</p>

              <v-btn :disabled="!formIsValid" class="" @click="getAllMonthData" color="blue" dark >Apply</v-btn>
              <br><br>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <br>
        
        <!-- Summary Boxes -->
        <v-row>
          <v-col>
            <v-card
              class="pa-2"
              outlined
              tile
            >
              <p><b>TOTAL : </b></p>
              <p>{{displayList.length}}</p>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="pa-2"
              outlined
              tile
            >
              <p><b>TODAY : </b></p>
              <p>{{displayToday}}</p>
            </v-card>
          </v-col>
        </v-row>
        <br>

        <!-- Download Excel -->
        <vue-excel-xlsx
          :data="displayList"
          :columns="excelColumns"
          :file-name="excelFilename"
          :file-type="'xlsx'"
          :sheet-name="excelSheetname"
          v-show="isDisplayListPopulated"
          >
            <v-btn class="" color="green" dark >Download Excell</v-btn>
        </vue-excel-xlsx>
        <br><br>  
        <hr>
        <br>
  
        <!-- Pagination for all records -->
        <div class="text-center mx-2 px-1">
          <v-pagination
            v-model="page"
            :length="pagesLength"
            @input="updatePage"
            v-show="isDisplayListPopulated"
          ></v-pagination>
        </div>
        <!-- ListView for all records -->
        <div class="text-start">
          <v-col v-show="record=='sign_in'" >
            <v-col
              v-for="(item, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{item.agent_code}}</p>
              <p class="pl-2"><b>TIME :</b> {{item.date}} || {{item.time}}</p>
              <hr>
            </v-col>
          </v-col>

          <v-col v-show="record=='e_contract'" >
            <v-col
              v-for="(list, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{list.agent_code}}</p>
              <p class="pl-2"><b>AGENT NAME :</b> {{list.agent_name}}</p>
              <p class="pl-2"><b>TIME :</b> {{list.date}} || {{list.time}}</p>
              <p class="pl-2"><b>CONTRACT DATE :</b> {{list.contract_date}}</p>
              <hr>
            </v-col>
          </v-col>

          <v-col v-show="record=='e_proposal_term_80'" >
            <v-col
              v-for="(list, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{list.agent_code}}</p>
              <p class="pl-2"><b>AGENT NAME :</b> {{list.agent_name}}</p>
              <p class="pl-2"><b>TIME :</b> {{list.date}} || {{list.time}}</p>
              <p class="pl-2"><b>CLIENT NAME :</b> {{list.client_name}}</p>
              <p class="pl-2"><b>OBJECTIVE :</b> {{list.objective}}</p>
              <hr>
            </v-col>
          </v-col>

          <v-col v-show="record=='e_proposal_pro_essential'" >
            <v-col
              v-for="(list, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{list.agent_code}}</p>
              <p class="pl-2"><b>AGENT NAME :</b> {{list.agent_name}}</p>
              <p class="pl-2"><b>TIME :</b> {{list.date}} || {{list.time}}</p>
              <p class="pl-2"><b>CLIENT NAME :</b> {{list.client_name}}</p>
              <p class="pl-2"><b>OBJECTIVE :</b> {{list.objective}}</p>
              <hr>

            </v-col>
          </v-col>

          <v-col v-show="record=='witness_program'" >
            <v-col
              v-for="(list, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{list.agent_code}}</p>
              <p class="pl-2"><b>TIME :</b> {{list.date}} || {{list.time}}</p>
              <p class="pl-2"><b>POLICY HOLDER NAME :</b> {{list.policy_holder_name}}</p>
              <p class="pl-2"><b>FORM DATE :</b> {{list.policy_holder_date}}</p>
              <hr>

            </v-col>
          </v-col>

          <v-col v-show="record=='ipod_booking'">
            <v-col
              v-for="(list, index) in historyList"
              :key="index"
              class="pl-2"
            >
              <p class="pl-2"><b>AGENT CODE :</b> {{list.agent_code}}</p>
              <p class="pl-2"><b>AGENT NAME :</b> {{list.agent_name}}</p>
              <p class="pl-2"><b>Date :</b> {{list.date}} </p>
              <p class="pl-2"><b>Room :</b> {{list.room}}</p>
              <p class="pl-2"><b>Access Card :</b> {{list.access_card}}</p>
              <p class="pl-2">Take : {{list.take_date}}</p>
              <p class="pl-2">Return : {{list.return_date}}</p>
              <hr>

            </v-col>
          </v-col>

        </div>

      </v-col>
    </v-row>

    <!-- SignIn Div -->
    <v-row v-else class="text-center"> 
      <v-col>
        <br><br><br>
        <v-form
          ref="form"
          @submit.prevent="signInAsAdmin"
        >
          <h3>Please enter admin's password to continue</h3>
          <br>                    
          <v-text-field
            v-model="password"

            label="Password"
            outlined
            dense
            :append-icon="show3 ? mdiEye : mdiEyeOff"
            :type="show3 ? 'text' : 'password'"
            @click:append="show3 = !show3"
          ></v-text-field>

          <v-btn :disabled="!formIsValid_SignIn" color="primary" type="submit" >Sign In</v-btn>
          <br>
        </v-form>

        <v-overlay :value="overlay">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            <h3 class="title ma-3">Signing In</h3>
            <br>
            
            <!--
            <v-btn
            icon
            @click="overlay = false"
            x-large
            
            >
            <v-icon>mdi-close</v-icon>
            Dismiss
            </v-btn>-->

        </v-card>
        </v-overlay>
        <v-overlay :value="overlayError">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <h3 class="title ma-3">Password Error !</h3><p class="sub-title">Please enter correct password.</p>
            
            <v-btn
            icon
            @click="overlayError = false"
            x-large
            
            >
            <v-icon>{{mdiClose}}</v-icon>
            Dismiss
            </v-btn>
        </v-card>
        </v-overlay>
        <v-overlay :value="overlayInfoError">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <h3 class="title ma-3">Invalid Input.</h3><p class="sub-title">Please fill up the form.</p>
            
            <v-btn
            icon
            @click="overlayInfoError = false"
            x-large
            
            >
            <v-icon>{{mdiClose}}</v-icon>
            Dismiss
            </v-btn>
        </v-card>
        </v-overlay>
      </v-col>
    </v-row>

    <!-- snackbar: error reading db. -->
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :multi-line="snackbarMultiLine"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    
  </v-container>
</template>

<script>
  import { getDatabase, ref, push, child, get, onValue } from "firebase/database";
  import { dbPaths } from "../assets/dbPaths.js";
  import {  mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'

  import VueExcelXlsx from "vue-excel-xlsx/VueExcelXlsx.vue"

  export default {
    components: {
      VueExcelXlsx
    },
    data () {
      return {
        mdiClose,
        mdiEye,
        mdiEyeOff,
        isAdmin: '',
        overlay: false,
        overlayError: false,
        overlayInfoError: false,
        password: '',
        show3: false,
        rules: {text: [val => (val || '').length > 0 || 'This field is required'],},
        recordItems: [
          { item: 'SIGN IN', value: 'sign_in' }, 
          { item: 'E-CONTRACT', value: 'e_contract' }, 
          { item: 'E-PROP TERM 80', value: 'e_proposal_term_80' }, 
          { item: 'E-PROP PRO ESSENTIAL', value: 'e_proposal_pro_essential' }, 
          { item: 'WITNESS PROGRAM', value: 'witness_program' },
          { item: 'IPOD BOOKING', value: 'ipod_booking' },
        ],
        monthItems: [
          { item: 'JANUARY', value: '0' }, 
          { item: 'FEBRUARY', value: '1' }, 
          { item: 'MARCH', value: '2' }, 
          { item: 'APRIL', value: '3' }, 
          { item: 'MAY', value: '4' }, 
          { item: 'JUNE', value: '5' }, 
          { item: 'JULY', value: '6' }, 
          { item: 'AUGUST', value: '7' }, 
          { item: 'SEPTEMBER', value: '8' }, 
          { item: 'OCTOBER', value: '9' }, 
          { item: 'NOVEMBER', value: '10' }, 
          { item: 'DECEMBER', value: '11' },
          { item: 'ALL MONTHS', value: '12' },
        ],
        yearItems: [
          { item: '2022', value: '2022' },
          { item: '2023', value: '2023' },
          { item: '2024', value: '2024' } 
        ],

        record: 'sign_in',
        year: '2022',
        month: '1',

        displayTotal: '',
        displayToday: 0,
        displayList: [],
        isDisplayListPopulated: false,

        todayDate: '',

        page: 1,
        pageSize: 10,
        historyList: [], //used for pagination.

        pagesLength: 1,
        calculatingLength: 0,

        snackbar: false,
        snackbarText: '',
        snackbarTimeout: 5000,
        snackbarMultiLine: false,

        //export excell.
        excelColumns : [],
        excelFilename: '',
        excelSheetname: '',
        
      }
    },

    computed: {
      formIsValid_SignIn() {
        return this.password
      },
      formIsValid() {
        return this.record && this.year && this.month 
      },
    },

    methods: {
      signInAsAdmin() {
        // do your submit logic here                    
        this.overlay = true
        if (this.password === 'adminTSA') {

            const db = getDatabase();
            const date = new Date();

            push(ref(db, dbPaths.toAdminSignIn() + date.getFullYear() + '/' + date.getMonth() ), {
                agent_code: window.sessionStorage.getItem('agentCode').toUpperCase(),
                date: date.toDateString(), 
                time: date.toLocaleTimeString(),
            })
            .then(() => {
                // Data saved successfully!
                
                this.overlay = true
                window.sessionStorage.setItem('isAdmin', true)
                this.isAdmin = true
                this.overlay = false
            })
            .catch((error) => {
                // The write failed...
                console.log(error);
            });

        } else {
            this.overlayError = true
        }
      },

      signOutAsAdmin() {
        this.password = ''
        window.sessionStorage.setItem('isAdmin', false)
        this.isAdmin = false 
      },

      getAllMonthData() {
        this.displayList = []
        this.displayToday = 0
        this.historyList = []
        this.isDisplayListPopulated = false

        this.calculatingLength = 0
        this.pagesLength = 0

        this.setExcelSettings(this.record)

        console.log('monthItems.item == ' + this.monthItems[this.month].item);

        if (this.record === "ipod_booking") {
          //get data from db. While looping, make new obj, push into array.
          const db = getDatabase();
          const dbRef = ref(db, `records/ipod_booking_confirmed/${this.year}`);

          get(dbRef).then((snapshot) => {
            if (snapshot.exists()) {
              //console.log(snapshot.val());
              snapshot.forEach((childSnapshot) => {
                //const childKey = childSnapshot.key;
                //const timeDb = childSnapshot.val().date;
                //console.log(childData);

                //if (timeDb === this.todayDate) this.displayToday++

                let newObj = {
                  agent_code: childSnapshot.val().agent_code,
                  agent_name: childSnapshot.val().name,
                  date: this.getDateStr(childSnapshot.val().start),
                  room: this.getRoomName(childSnapshot.val().room),
                  access_card: childSnapshot.val().adm_access_card,
                  take_date: childSnapshot.val().adm_access_card_take_date,
                  return_date: childSnapshot.val().adm_access_card_return_date,
                } 

                //this.displayList.push(childSnapshot.val())

                this.displayList.push(newObj)
                this.calculatingLength++

              });

              this.isDisplayListPopulated = true

              //console.log('initPage: calcLength ==> ' + this.calculatingLength);

              this.pagesLength = Math.ceil(this.calculatingLength / this.pageSize)
              //console.log('initPage: pagesLength ==> ' + this.pagesLength);

              if (this.calculatingLength < this.pageSize) {
                this.historyList = this.displayList;
              } else {
                this.historyList = this.displayList.slice(0, this.pageSize);
              }

            } else {
              console.log("No data available == ipodbooking ");
              this.snackbar = true
              this.snackbarText = "No data available."
            }
          }).catch((error) => {
            console.error(error);
            this.snackbar = true
            this.snackbarText = "Reading Database Error"
          });

        } else {

          if(this.month === '12') {
            //console.log('getAllMonthData: ALL == ' + this.month);
            for (let month = 0; month < 12; month++) {
              var monthStr = month.toString()
              //console.log('getAllMonthData: monthStr == ' + monthStr);

              const db = getDatabase();
              const dbRef = ref(db, `records/${this.record}/${this.year}/${monthStr}`);

              get(dbRef).then((snapshot) => {
                if (snapshot.exists()) {
                  //console.log(snapshot.val());
                  snapshot.forEach((childSnapshot) => {
                    //const childKey = childSnapshot.key;
                    const timeDb = childSnapshot.val().date;
                    //console.log(childData);

                    if (timeDb === this.todayDate) this.displayToday++

                    this.displayList.push(childSnapshot.val())
                    this.calculatingLength++

                  });

                  this.isDisplayListPopulated = true

                  //console.log('initPage: calcLength ==> ' + this.calculatingLength);

                  this.pagesLength = Math.ceil(this.calculatingLength / this.pageSize)
                  //console.log('initPage: pagesLength ==> ' + this.pagesLength);

                  if (this.calculatingLength < this.pageSize) {
                    this.historyList = this.displayList;
                  } else {
                    this.historyList = this.displayList.slice(0, this.pageSize);
                  }

                } else {
                  console.log("No data available == month " + month);
                }
              }).catch((error) => {
                console.error(error);
              });
              
            }

          } else {
            console.log('getAllMonthData: ONLY == ' + this.month);

            const db = getDatabase();
            const dbRef = ref(db, `records/${this.record}/${this.year}/${this.month}`);

            get(dbRef).then((snapshot) => {
              if (snapshot.exists()) {
                //console.log(snapshot.val());

                snapshot.forEach((childSnapshot) => {
                  //const childKey = childSnapshot.key;
                  const timeDb = childSnapshot.val().date;
                  //console.log(childData);

                  if (timeDb === this.todayDate) this.displayToday++

                  this.displayList.push(childSnapshot.val())
                  this.calculatingLength++

                });
                this.isDisplayListPopulated = true

                //this.listCount = this.displayList.length; listCount replaced by calculatingLength.
                //console.log('initPage: calcLength ==> ' + this.calculatingLength);

                this.pagesLength = Math.ceil(this.calculatingLength / this.pageSize)
                //console.log('initPage: pagesLength ==> ' + this.pagesLength);

                if (this.calculatingLength < this.pageSize) {
                  this.historyList = this.displayList;
                } else {
                  this.historyList = this.displayList.slice(0, this.pageSize);
                }

              } else {
                console.log("No data available");
                this.snackbar = true
                this.snackbarText = "No data available."
              }
            }).catch((error) => {
              console.error(error);
              this.snackbar = true
              this.snackbarText = "Reading Database Error"
            });

          }
        }

        
        
      },

      //to get room info based on room no.
      getRoomName(roomNo) {
        switch (roomNo) {
          case "1" :
            return 'IPod 1';
          case "2" :
            return 'IPod 2';
          case "3" :
            return 'IPod Hall';
          case "4" :
            return 'IPod Pingpong';
        
          default:
            return 'error';
        }
      },
      getDateStr(timestamp) {
        var date = new Date(timestamp)
        var dateStr = date.toLocaleString()
        return dateStr
      },

      setExcelSettings(recordName) {
        switch (recordName) {
          case "sign_in":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Date",
                field: "date",
              },
              {
                label: "Time",
                field: "time",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_SignIn_Records_' + this.monthItems[this.month].item
            this.excelSheetname = this.monthItems[this.month].item
            
            break;

          case "e_contract":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Agent Name",
                field: "agent_name",
              },
              {
                label: "Date Submit",
                field: "date",
              },
              {
                label: "Date (on contract)",
                field: "contract_date",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_EContract_Records_' + this.monthItems[this.month].item
            this.excelSheetname = this.monthItems[this.month].item
            
            break;

          case "e_proposal_term_80":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Agent Name",
                field: "agent_name",
              },
              {
                label: "Client Name",
                field: "client_name",
              },
              {
                label: "Date",
                field: "date",
              },
              {
                label: "Objective",
                field: "objective",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_EPropTerm80_Records_' + this.monthItems[this.month].item
            this.excelSheetname = this.monthItems[this.month].item
            
            break;

          case "e_proposal_pro_essential":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Agent Name",
                field: "agent_name",
              },
              {
                label: "Client Name",
                field: "client_name",
              },
              {
                label: "Date",
                field: "date",
              },
              {
                label: "Objective",
                field: "objective",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_EPropProEss_Records_' + this.monthItems[this.month].item
            this.excelSheetname = this.monthItems[this.month].item
            
            break;

          case "witness_program":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Agent Name",
                field: "agent_name",
              },
              {
                label: "Date",
                field: "date",
              },
              {
                label: "Client Name",
                field: "policy_holder_name",
              },
              {
                label: "Witness 1",
                field: "first_witness_name",
              },
              {
                label: "Witness 2",
                field: "second_witness_name",
              },
              {
                label: "Witness 3",
                field: "third_witness_name",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_WitnessProgram_Records_' + this.monthItems[this.month].item
            this.excelSheetname = this.monthItems[this.month].item
            
            break;

          case "ipod_booking":
            this.excelColumns = [
              {
                label: "Agent Code",
                field: "agent_code",
              },
              {
                label: "Agent Name",
                field: "agent_name",
              },
              {
                label: "Date",
                field: "date",
              },
              {
                label: "Room",
                field: "room",
              },
              {
                label: "Acc Card",
                field: "access_card",
              },
              {
                label: "Take Date",
                field: "take_date",
              },
              {
                label: "Return Date",
                field: "return_date",
              },
            ]
            this.excelFilename = 'ADMIN_TSA_IPodBooking_Records_' + this.year
            this.excelSheetname = this.year
            
            break;
        
          default:
            break;
        }
      },

      updatePage(pageIndex) {
        let _start = (pageIndex - 1) * this.pageSize;
        let _end = pageIndex * this.pageSize;
        this.historyList = this.displayList.slice(_start, _end);
        this.page = pageIndex;
      },

      

      //test & unused.
      submitFilter() {
        const dbRef = ref(getDatabase());
        get(child(dbRef, `records/${this.record}/${this.year}/${this.month}`)).then((snapshot) => {
          if (snapshot.exists()) {
            this.displayList = snapshot.val()
            console.log(Array.isArray(snapshot));
    
          } else {
            console.log("No data available");
          }
        }).catch((error) => {
          console.error(error);
        });
      },

      submitFilter2() {

        this.displayList = []
        this.displayToday = 0
        const db = getDatabase();
        const dbRef = ref(db, `records/${this.record}/${this.year}/${this.month}`);

        onValue(dbRef, (snapshot) => {
          snapshot.forEach((childSnapshot) => {
            //const childKey = childSnapshot.key;
            const timeDb = childSnapshot.val().date;
            //console.log(childData);

            if (timeDb === this.todayDate) this.displayToday++

            //compare todayData with childData. if true, todayDisplay++

            this.displayList.push(childSnapshot.val())




            //this.displayList.push(childSnapshot)
            //console.log(Array.isArray(this.displayList));
            //console.log(this.displayList);
            
          });
          this.isDisplayListPopulated = true

        }, {
          onlyOnce: true
        });
      },

      

    },

    created() {
      //this.initPage();
      //this.updatePage(this.page);
    },

    mounted() {
      this.todayDate = new Date().toDateString()
      //console.log('mounted: ' + this.todayDate);
      if (window.sessionStorage.getItem('isAdmin') == 'true') {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }

    },

    destroyed() {
      //console.log('admin destroyed');
      //window.sessionStorage.setItem('isLeader', false)
    }
  }
</script>